import React from 'react'
import { FastField, Field } from 'formik'

import FormikInput from '../FormikInput'
import FormikSelect, { Option } from '../FormikSelect'
import { buzzlRoles } from '../../utils/config'
import { BuzzlUserDTO } from '../../types/buzzl-user'
import { useUserByEmail } from '../../hooks/useUser'
import { UserName } from '../../types/user'

type BuzzlUserFormProps = {
  isSubmitting: boolean
  customers: Option[]
  showCustomers: boolean
  values: BuzzlUserDTO
}

const BuzzlUserForm: React.FC<BuzzlUserFormProps> = (props) => {
  const firstNameRef = React.useRef<HTMLInputElement>(null)
  const lastNameRef = React.useRef<HTMLInputElement>(null)
  const prevDataRef = React.useRef<UserName | null | { user: null }>(null)

  const { data } = useUserByEmail(props.values.email)

  const userMemo = React.useMemo(() => {
    if (data && prevDataRef.current?.user !== data.user) {
      return data
    }
  }, [data])

  React.useEffect(() => {
    if (data && data.user) {
      props.values.firstName = data.user.firstName
      if (firstNameRef?.current) {
        firstNameRef.current.value = data.user.firstName
      }

      props.values.lastName = data.user.lastName
      if (lastNameRef?.current) {
        lastNameRef.current.value = data.user.lastName
      }
      prevDataRef.current = data
    } else {
      props.values.firstName = ''
      if (firstNameRef?.current) {
        firstNameRef.current.value = ''
      }

      props.values.lastName = ''
      if (lastNameRef?.current) {
        lastNameRef.current.value = ''
      }
      prevDataRef.current = { user: null }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMemo])

  return (
    <div className="divide-y divide-gray-200 px-4 sm:px-6">
      <fieldset className="space-y-6 pt-6 pb-5" disabled={props.isSubmitting}>
        <Field
          name="role"
          component={FormikSelect}
          label="Role"
          options={[
            { label: 'Admin', value: buzzlRoles.admin },
            { label: 'Operator', value: buzzlRoles.operator },
          ]}
        />
        <FastField type="email" name="email" component={FormikInput} label="Email" placeholder="user@email.com" />
        {/* <FastField type="text" name="displayName" component={FormikInput} label="Display Name" placeholder="name" /> */}
        <FastField
          type="text"
          name="firstName"
          component={FormikInput}
          label="First Name"
          innerRef={firstNameRef}
          placeholder="First Name"
        />
        <FastField
          type="text"
          name="lastName"
          component={FormikInput}
          label="Last Name"
          innerRef={lastNameRef}
          placeholder="Last Name"
        />
      </fieldset>
      {props.customers.length > 0 && props.showCustomers && (
        <fieldset className="space-y-6 pt-6 pb-5" disabled={props.isSubmitting}>
          <div className="flex flex-col">
            <label className="mb-2 text-base font-semibold leading-6">Assign Customers</label>
            <label className="text-sm font-normal leading-5 text-gray-500">
              If you’d like to limit access to specific customers you can specify access below.{' '}
            </label>
          </div>

          <Field name="customers" component={FormikSelect} label="Assign Customers" isMulti options={props.customers} />
        </fieldset>
      )}
    </div>
  )
}

export default BuzzlUserForm
